import React, { useCallback, useContext, useEffect, useState } from "react";
import styles from "./FontSelector.module.css";
import Form from "react-bootstrap/Form";
import { AppContext } from "../../components/provider/AppContext";
import BorderRenderer from "../../components/borderProvider/BorderRenderer";
import { useSwipeable } from "react-swipeable";
import { useNavigate } from "react-router-dom";

const FontSelector = () => {
  const { appData, setAppData } = useContext(AppContext);
  const [fontSelected, setFontSelected] = useState(null);
  const [letters, setLetters] = useState({ 0: "", 1: "", 2: "" });
  const [borderSelected, setBorderSelected] = useState(null);
  const [colorSelected, setColorSelected] = useState(null);
  const [noMonoGramChecked, setMonoGramChecked] = useState();
  const fontOptions = ["Modern", "Elegant", "Hand written"];
  const borderOptions = ["Diamond", "Circle", "Botanical"];
  const colorOptions = ["Silver", "Gold", "Rose Gold"];
  const resetContext = useCallback(() => {
    setAppData({
      ...appData,
      letters: "",
      border: "",
      borderColor: "",
      font: "",
      noMonoGram: !noMonoGramChecked,
    });
  }, [appData, setAppData]);
  useEffect(() => {
    if (appData) {
      if (appData?.letters && appData?.letters !== "") {
        setLetters({
          0: appData?.letters[0],
          1: appData?.letters[1],
          2: appData?.letters[2],
        });
      }
      if (appData?.border && appData?.border !== "") {
        setBorderSelected(appData?.border);
      }
      if (appData?.borderColor && appData?.borderColor !== "") {
        setColorSelected(appData?.borderColor);
      }
      if (appData?.font && appData?.font !== "") {
        setFontSelected(appData?.font);
      }
      if (appData?.noMonoGram && appData?.noMonoGram !== "") {
        console.log(appData.noMonoGram);
        setMonoGramChecked(appData?.noMonoGram);
      }
    }
  }, [appData, resetContext]);
  const passContext = (key, value) => {
    setAppData({
      ...appData,
      [key]: value,
    });
    localStorage.setItem("appData", JSON.stringify(appData));
  };

  const navigate = useNavigate();

  const handleChange = ({ target }, index) => {
    const currLetters = JSON.parse(JSON.stringify(letters));
    const isValid = /^[A-Za-z0-9]*$/.test(target.value);
    if (!isValid) {
      return;
    }
    currLetters[index] = target.value;
    setLetters((prevLetters) => ({
      ...prevLetters,
      [index]: target.value,
    }));
    passContext("letters", currLetters);
  };

  const fontStyle = {
    fontFamily: fontSelected === "Modern" ? "Roboto" : fontSelected,
    zIndex: 2,
  };

  useEffect(() => {
    const updatedData = {
      ...appData,
      nextPageText: "Complete",
      backPageText: "Template",
      nextPageLink: "complete",
      backPageLink: "template",
      currentPage: 2,
    };
    setAppData(updatedData);
  }, []);

  const handlers = useSwipeable({
    onSwipedRight: () => navigate("/template"),
  });
  return (
    <>
      <div
        className={`container-fluid d-flex flex-column justify-content-center align-items-center ${styles["fade-in"]}`}
        style={{ paddingTop: "0.1rem", height: "80vh" }}
        {...handlers}
      >
        <div
          className={`container-fluid d-flex flex-column justify-content-center ${styles["displayer"]} align-items-center`}
          style={{ height: "75vh" }}
        >
          <BorderRenderer
            borderSelected={borderSelected}
            colorSelected={colorSelected}
          />
          <h3
            className={`d-flex flex-row ${styles["" + borderSelected]}`}
            style={fontStyle}
          >
            {Object.values(letters).map((value, index) => (
              <p key={index}>{value}</p>
            ))}
          </h3>
        </div>
        <br></br>
        <div className=" d-flex justify-content-center align-items-center flex-column">
          <div
            className={`d-flex flex-row justify-content-center align-items-center  w-50`}
          >
            <input
              disabled={noMonoGramChecked}
              value={letters[0]}
              onChange={(event) =>
                event.target.value.length <= 1 ? handleChange(event, 0) : "nada"
              }
              style={{ width: "25%", textAlign: "center" }}
              className="form-control"
            />
            <input
              disabled={noMonoGramChecked}
              value={letters[1]}
              onChange={(event) =>
                event.target.value.length <= 1 ? handleChange(event, 1) : "nada"
              }
              style={{ width: "25%", marginLeft: "10px", textAlign: "center" }}
              className="form-control"
            />
            <input
              disabled={noMonoGramChecked}
              value={letters[2]}
              onChange={(event) =>
                event.target.value.length <= 1 ? handleChange(event, 2) : "nada"
              }
              style={{
                width: "25%",
                marginLeft: "10px",
                textAlign: "center",
                display: borderSelected === "Botanical" ? "none" : "",
              }}
              className="form-control"
            />
          </div>
          <br></br>
          <label htmlFor="selectFont">Font style: </label>
          <select
            disabled={noMonoGramChecked}
            onChange={({ target }) => {
              setFontSelected(target.value);
              passContext("fontStyle", target.value);
            }}
            className="form-control"
            id="selectFont"
            value={fontSelected}
          >
            <option value={"No Template"}>Please Select a Font</option>
            {fontOptions.map((font) => {
              return (
                <option key={font} value={font}>
                  {font}
                </option>
              );
            })}
          </select>
          <label htmlFor="selectBorder">Border: </label>
          <select
            disabled={noMonoGramChecked}
            onChange={({ target }) => {
              setBorderSelected(target.value);
              passContext("border", target.value);
            }}
            className="form-control"
            id="selectBorder"
            value={borderSelected}
          >
            <option value={"No Border"}>Please Select a Border</option>
            {borderOptions.map((border) => {
              return (
                <option key={border} value={border}>
                  {border}
                </option>
              );
            })}
          </select>
          <label htmlFor="selectColor">Border Color: </label>
          <select
            disabled={noMonoGramChecked}
            onChange={({ target }) => {
              setColorSelected(target.value);
              passContext("borderColor", target.value);
            }}
            className="form-control"
            id="selectColor"
            value={colorSelected}
          >
            <option value={"No Color"}>Please Select Border Color</option>
            {colorOptions.map((color) => {
              return (
                <option key={color} value={color}>
                  {color}
                </option>
              );
            })}
          </select>
          <br></br>
          <Form>
            <Form.Switch
              type="radio"
              style={{ color: "red" }}
              label="No Monogram (-$5)"
              checked={noMonoGramChecked}
              onChange={() => {
                passContext("noMonoGram", !noMonoGramChecked);
                setMonoGramChecked(!noMonoGramChecked);
                if (noMonoGramChecked) {
                  resetContext();
                }
              }}
            />
          </Form>
        </div>
        <br></br>
      </div>
    </>
  );
};
export default FontSelector;
